module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var a = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var a in e) {
      n.d(r, a, function (t) {
        return e[t];
      }.bind(null, a));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 0);
}([function (e, t, n) {
  "use strict";

  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  n.r(t);

  var a = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e);
    }

    var t, n, a;
    return t = e, a = [{
      key: "changeHeightWidth",
      value: function value(e, t, n, r, a, o) {
        return n > r && (e = Math.round(e * r / n), n = r), e > t && (n = Math.round(n * t / e), e = t), a && n < a && (e = Math.round(e * a / n), n = a), o && e < o && (n = Math.round(n * o / e), e = o), {
          height: e,
          width: n
        };
      }
    }, {
      key: "resizeAndRotateImage",
      value: function value(e, t, n, r, a) {
        var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "jpeg",
            i = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 100,
            u = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : 0,
            l = i / 100,
            c = document.createElement("canvas"),
            d = e.width,
            h = e.height,
            g = this.changeHeightWidth(h, n, d, t, r, a);
        !u || 90 !== u && 270 !== u ? (c.width = g.width, c.height = g.height) : (c.width = g.height, c.height = g.width), d = g.width, h = g.height;
        var f = c.getContext("2d");
        return u && (f.rotate(u * Math.PI / 180), 90 === u ? f.translate(0, -c.width) : 180 === u ? f.translate(-c.width, -c.height) : 270 === u ? f.translate(-c.height, 0) : 0 !== u && 360 !== u || f.translate(0, 0)), f.drawImage(e, 0, 0, d, h), c.toDataURL("image/".concat(o), l);
      }
    }, {
      key: "b64toBlob",
      value: function value(e, t) {
        t = t || "image/jpeg";

        for (var n = atob(e.toString().replace(/^data:image\/(png|jpeg|jpg);base64,/, "")), r = [], a = 0; a < n.length; a += 512) {
          for (var o = n.slice(a, a + 512), i = new Array(o.length), u = 0; u < o.length; u++) {
            i[u] = o.charCodeAt(u);
          }

          var l = new Uint8Array(i);
          r.push(l);
        }

        return new Blob(r, {
          type: t
        });
      }
    }, {
      key: "createResizedImage",
      value: function value(t, n, r, a, o, i, u) {
        var l = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : "base64",
            c = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : null,
            d = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : null,
            h = null,
            g = new FileReader();
        t ? (g.readAsDataURL(t), g.onload = function () {
          var t = new Image();
          t.src = g.result, t.onload = function () {
            var g = e.resizeAndRotateImage(t, n, r, c, d, a, o, i);
            h = e.b64toBlob(g, "image/".concat(a)), u("blob" === l ? h : g);
          };
        }, g.onerror = function (e) {
          u(e);
        }) : u("File Not Found");
      }
    }], (n = null) && r(t.prototype, n), a && r(t, a), e;
  }();

  t.default = {
    imageFileResizer: function imageFileResizer(e, t, n, r, o, i, u, l, c, d) {
      return a.createResizedImage(e, t, n, r, o, i, u, l, c, d);
    }
  };
}]);